let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eZRzs")).then(() => parcelRequire('iF5yO'));